import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { HiDownload } from 'react-icons/hi';
import { SupportMaterial, SupportMaterialTypes } from 'store/product/types';
import findSupportMaterial from 'utils/findSupportMaterial';
import embededYoutubeVideo from 'utils/embededYoutubeVideo';
import styles from './StudioSupportMaterials.module.scss';

export interface StudioSupportMaterialsProps {
  supportMaterials: SupportMaterial[];
}

const StudioSupportMaterials: FC<StudioSupportMaterialsProps> = ({ supportMaterials }) => {
  const { t } = useTranslation();
  if (!supportMaterials) {
    return null;
  }
  const pdfLink = findSupportMaterial(supportMaterials, SupportMaterialTypes.supporting_materials_instruction_pdf_url);
  const youtubeVideoLink = findSupportMaterial(
    supportMaterials,
    SupportMaterialTypes.supporting_materials_instruction_video_url,
  );
  let embededVideo;
  if (youtubeVideoLink) {
    embededVideo = embededYoutubeVideo(youtubeVideoLink);
  }

  return (
    <div className={styles.supportMaterials}>
      {embededVideo && <div dangerouslySetInnerHTML={{ __html: embededVideo || '' }} />}
      {pdfLink && (
        <div className={styles.pdfSection}>
          <a href={pdfLink} target="_blank" rel="noreferrer">
            <HiDownload size="17" />
            <span>{t('txt_download_manual_here')}</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default StudioSupportMaterials;
